// Generated by Melange

import * as Buhta_cabinet__Box from "../../components/html/Box.js";
import * as Buhta_cabinet__Button from "../../components/html/Button.js";
import * as Buhta_cabinet__FormView from "../../components/html/FormView.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_components__ToastContainer from "../../../../../packages/components/src/moleculas/ToastContainer.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function ClientLogoutForm(Props) {
  let payload = Props.payload;
  const match = React.useState(function () {
        
      });
  const setToast = match[1];
  let tmp;
  let exit = 0;
  if (payload !== undefined && !(typeof payload === "string" || payload.NAME !== "ClientLoginPayload")) {
    const payload$1 = payload.VAL;
    tmp = JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
          onSubmit: (function (param) {
              
            }),
          action: "/client/logout",
          method_: "POST",
          className: "mt-8",
          children: [
            JsxRuntime.jsx("input", {
                  name: "_csrf",
                  type: "hidden",
                  value: payload$1.csrfToken
                }),
            JsxRuntime.jsx("input", {
                  name: "challenge",
                  type: "hidden",
                  value: payload$1.challenge
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                          kind: "default",
                          name: "submit",
                          value: "reject",
                          type_: "submit",
                          isWide: true,
                          children: "Отмена"
                        }),
                    JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                          kind: "primary",
                          name: "submit",
                          value: "accept",
                          type_: "submit",
                          isWide: true,
                          children: "Выйти"
                        })
                  ],
                  className: "flex space-x-3 mt-4"
                })
          ]
        });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          children: "No csrf token provided"
        });
  }
  return JsxRuntime.jsx(Buhta_components__ToastContainer.make, {
              toast: match[0],
              onExpired: (function (param) {
                  Curry._1(setToast, (function (param) {
                          
                        }));
                }),
              children: JsxRuntime.jsxs(Buhta_cabinet__Box.make, {
                    title: "Выход",
                    className: "relative",
                    children: [
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                            className: "text-gray-medium",
                            children: "Подтвердите ваше действие"
                          }),
                      tmp
                    ]
                  })
            });
}

const make = ClientLogoutForm;

export {
  make ,
}
/* Buhta_cabinet__Box Not a pure module */
